<template>
    <div>
        <vs-input
                icon="search"
                class="w-full"
                @keyup="searchFile"
                placeholder="Search Files"
                v-model="searchKey"
                size="large"
              />
    </div>
</template>

<script>

import {folder_list } from '@/api/file.js'
export default {
  name: 'search',
 
  data () {
    return {
      searchKey: '',
      file1: []
    }
  },
  computed: {
    
  },
  mounted () {
    folder_list()
      .then((res) => {
        this.file1 = res.data.data.repository
        //
      })
      .catch((e) => {
        
      })
  },
  methods: {
    filteredData (data) {
      this.$emit('filteredData', data)
    },
    searchFile () {
      
      if (!this.searchKey.toLowerCase().trim()) {
        this.filteredData(this.file1)
      } else {
        this.filteredData(this.file1.filter(c => c.repository_name.toLowerCase().indexOf(this.searchKey.toLowerCase().trim()) > -1))
      }
    }

  }
}
</script>